import { render } from "./uncodedStatus24hShift.vue?vue&type=template&id=dc3a5e10"
import script from "./uncodedStatus24hShift.vue?vue&type=script&lang=js"
export * from "./uncodedStatus24hShift.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__